import { AppState } from '../../../../types'

const selectors: any = {
  getAll: (state: AppState) => state.monitoring.logPoints.apps,
  logPointsConnectors: (state: AppState) => selectors.getAll(state).logPointsConnectors,
  logPointsConnectorsLoading: (state: AppState) => selectors.getAll(state).logPointsConnectorsLoading,
  isSaving: (state: AppState) => selectors.getAll(state).logPointsConnectorsSaving,
  hasSavedYet: (state: AppState) => selectors.getAll(state).hasSavedYet,
  error: (state: AppState) => selectors.getAll(state).error
}

export default selectors
